<template>
  <div class="page-content-wrapper user-list-page" v-check-permission="'sync-permissions'">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card m-b-20">
            <div class="card-block">

              <h4 class="mt-0 header-title">Permisos</h4>
              <p class="text-muted m-b-30 font-14">Desde aquí podras sincronizar los permisos de la App con el API REST cada vez que se agreguen modulos y/o permisos nuevos.</p>

              <div class="table-rep-plugin">
                <div class="table-responsive b-0" data-pattern="priority-columns">
                  <table class="table table-striped">
                    <thead>
                    <tr>
                      <th>Permiso</th>
                      <th>Clave</th>
                      <th>Modulo</th>
                      <th>Descripción</th>
                      <th>Estado</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="permission in localPermissions">
                      <td>{{ permission.name }}</td>
                      <td>{{ permission.key }}</td>
                      <td>{{ permission.module }}</td>
                      <td>{{ permission.description }}</td>
                      <td><span class="badge badge-success" v-if="permission.synced">Sincronizado</span><span class="badge badge-primary" v-if="!permission.synced">No sincronizado</span> </td>
                    </tr>
                    <tr v-if="localPermissions.length === 0">
                      <td colspan="4">Aun no se han creado permisos.</td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="btn-toolbar">
                    <div class="btn-group dropdown-btn-group pull-right">
                      <a v-if="enableSync" href="javascript:void(0);" @click="syncPermissions()" class="btn btn-primary waves-effect waves-light">Sincronizar</a>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- end col -->
      </div> <!-- end row -->

    </div><!-- container -->

  </div>
</template>


<script>
  import localPermissions from '../data/permissions'

  export default {
    name: 'permission-manager',
    created () {
      this.getAllPermissions()
    },


    data () {
      return {
        localPermissions: localPermissions,
        enableSync: false
      }
    },


    computed: {
      permissions: function () {
        return this.$store.getters.getAllPermissions
      }
    },


    methods: {

      getAllPermissions () {
        var self = this
        self.$loader.loading();
        this.$store.dispatch('getAllPermissions')
          .then((response) => {
            self.$loader.close();
            this.localPermissions.map(function(item, index) {
              let perm = self.getPermissionByKey(item.key)
              if (perm.length === 0) {
                item.synced = false
              } else {
                item.synced = true
              }
              if (index +1 === self.localPermissions.length) {
                self.enableSync = self.localPermissions.some(perm => !perm.synced)
              }
            })
          })
          .catch((response) => {
            self.$loader.close();
            self.$message.error({text: response.message});
          })
      },


      getPermissionByKey: function (key) {
        return this.$store.state.permissions.filter(permission => (permission.key === key))
      },


      addPermission (permission) {
        return this.$store.dispatch('addPermission', { permission: permission })
      },


      syncPermissions () {
        var self = this
        this.localPermissions.map(function(item, index) {
          let perm = self.getPermissionByKey(item.key)
          if (perm.length === 0) {
            var promise = self.addPermission({key: item.key, name: item.name, module: item.module})
            if (index +1 === self.localPermissions.length) {
              promise.then(function (response) {
                self.getAllPermissions()
              })
            }
          }
        })
      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/screens/PermissionManagerScreen.vue